import {Component, OnDestroy} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {select, Store} from "@ngrx/store";
import {IVirtualGridCollectionState} from "@shared/store/reducers/virtual-grid.reducer";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {QueryProvider} from "@shared/queries/query-provider";

@Component({
    standalone: false,
    selector: 'particle-activity-filter-country-selector',
  templateUrl: './activity-filter-country-selector.component.html',
  styleUrls: ['./activity-filter-country-selector.component.scss']
})
export class ActivityFilterCountrySelectorComponent implements IDialogView, OnDestroy {
  configKey: string;
  data: DialogModel;
  selectedCountries: any[] = [];
  selectedCountryCodes: any[] = [];
  valueChanged: boolean = false;
  allRecords: boolean = false;
  allCountries: any[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(private store: Store<IVirtualGridCollectionState>) {
    this.configKey = 'ActivityFilterCountrySelector';
  }

  ngOnInit() {
    //todo: if we use generic call then need to replace this by country service
    const config = QueryProvider.getQuery(this.configKey);
    QueryProvider.invokeQuery(this.store, this.configKey, {});
    this.selectedCountryCodes = this.data.input.selectedCountryCodes;
    this.allRecords = this.data.input.allRecords;
    if(!this.selectedCountryCodes) {
      this.selectedCountryCodes = [];
    }
    this.store.pipe(select(getQueryResponse, this.configKey), takeUntil(this.unsubscribe$)).subscribe(countries => {
      //console.log('[countires] ', countries);
      if(countries && countries.length) {
        this.allCountries = countries;
        if(this.allRecords) {
          this.selectedCountryCodes = this.allCountries.map(c => c.code);
        } else {
          this.selectedCountryCodes = this.selectedCountryCodes.filter(code => this.allCountries.findIndex(c => c.code === code) !== -1);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    //console.log('[selected countries:]', this.selectedCountries);
    this.data.input.selectedCountryCodes = this.valueChanged ? this.selectedCountries.map(o => o.value.code): this.selectedCountryCodes;
    this.data.input.allItemsSelected = this.data.input.selectedCountryCodes.length === this.allCountries.length;
    return true;
  }

  onSelectionChanged($event: any) {
    // console.log('[countries:]:', $event);
    this.selectedCountries = $event;
    this.valueChanged = true;
  }

}
